<div class="container">
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <span class="pe-0">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navContent" aria-controls="navContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </span>
      <div class="navbar-brand">
        @if (logoUrl) {
          <img class="logo" height="50" width="auto" alt="Organization Logo" [src]="logoUrl" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="office/{{ office.practiceId }}" id="organizationLogoLink" />
        } @else {
          <span class="office-name" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="office/{{ office.practiceId }}" id="officeNameLink">
            {{ office.name }}
          </span>
        }
      </div>
      <div class="spacer">&nbsp;</div>
      <div class="collapse navbar-collapse" id="navContent">
        <ul class="navbar-nav" style="width: 100%">
          <li class="nav-item">
            <a class="sub-header-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="faq" id="faqLink">FAQs</a>
          </li>
          <li class="nav-item">
            <a class="sub-header-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="support" id="supportLink">SUPPORT</a>
          </li>
          <li class="nav-item">
            <a class="sub-header-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="inviteAFriend()" (keyup)="inviteAFriend()" id="inviteAFriendLink">learn more</a>
          </li>
          <li class="nav-item nav-item--login">
            <a class="member-login" href="{{ environment.memberPortalLink }}" target="_blank" id="memberLoginButton">MEMBER LOGIN<i class="bi bi-box-arrow-up-right member-login__external" aria-hidden="true"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
